<template>
    <b-container fluid>
        <b-alert v-model="showError" variant="danger" dismissible>
            <p>{{ error }} / {{ error_data.message }}</p>
            <ul v-for="e in error_data.errors" :key="e">
                <li>{{ e }}</li>
            </ul>
        </b-alert>

        <!-- User / month / year picker -->
        <b-row class="mt-2 text-center">
            <b-col>
                <month-picker @change="changedMonthPicker"></month-picker>
            </b-col>

            <b-col>
                <b-form-select v-model="user" :options="users">
                    <template #first>
                      <b-form-select-option :value="null" disabled>Select user</b-form-select-option>
                    </template>
                </b-form-select>

                <b-button @click="getData()" variant="primary" :disabled="search_disabled" class="mt-4">Search</b-button>

                <!-- Available months / years -->
                <div class="mt-4 text-left">
                    <h6 v-if="available.years.length > 0">Available years:</h6>
                    <ul>
                        <li v-for="y in available.years" :key="y">
                            {{ y }}
                        </li>
                    </ul>
                </div>

                <div class="mt-2 text-left">
                    <h6 v-if="available.months.length > 0">Available months (in {{ year }}):</h6>
                    <ul>
                        <li v-for="m in available.months" :key="m">
                            {{ m }}
                        </li>
                    </ul>
                </div>

                <div class="mt-4 text-left">
                    <h5 v-if="items.length > 0">Total sms sent in {{ month }} / {{ year }}: <b>{{ total_sent }}</b></h5>
                </div>

            </b-col>
        </b-row>

        <!-- Table -->
        <b-table
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            stacked="md"
            show-empty
            small
            @filtered="onFiltered"
            class="mt-4"
        ></b-table>

        <div class="mt-4 d-flex">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
            ></b-pagination>
        </div>

    </b-container>
</template>

<script>

import { MonthPicker, MonthPickerInput } from 'vue-month-picker'

import axios from 'axios'
import moment from 'moment'

export default {
    name: 'Home',
    components: {
          MonthPicker,
          MonthPickerInput
    },

    data: () => ({
        users: [],
        user: null,
        year: null,
        month: null,
        total_sent: 0,

        available: {
            years: [],
            months: []
        },

        showError: false,
        error_data: '',
        error: '',
        items: [],
        fields: [
            { key: 'date', label: 'Date', sortable: true },
            { key: 'sent', label: 'Sent SMS', sortable: true }
        ],

        totalRows: 2,
        currentPage: 1,
        perPage: 20,
        pageOptions: [10,20,50,100,1000],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
    }),

    computed: {
        search_disabled: function () {
            var disabled = false

            if (this.user == null) {
                disabled = true
            }

            if (this.year == null) {
                disabled = true
            }

            if (this.month == null) {
                disabled = true
            }

            return disabled
        }
    },

    methods: {
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        changedMonthPicker(date) {
            this.month = date.monthIndex.toString()
            this.year = date.year.toString()

            if (this.month.length == 1) {
                this.month = '0' + date.monthIndex
            }

        },

        getData() {
            let url = process.env.BASE_URL + '/api/stats/' + this.user + '/' + this.year + '/' + this.month
            let config = {
              headers: {
                Token: sessionStorage.getItem('token')
              }
            }

            axios.get(url, config).then(response => {
                this.items = response.data
                this.showError = false

                this.total_sent = 0
                this.items.forEach(item => {
                    this.total_sent += parseInt(item.sent)
                })
            }).catch(err => {
                this.items = []
                this.getYears()
                this.getMonths()

                this.error = err
                this.error_data = err.response.data
                this.showError = true
            })
        },

        getYears() {
            let url = process.env.BASE_URL + '/api/stats/' + this.user
            let config = {
              headers: {
                Token: sessionStorage.getItem('token')
              }
            }

            axios.get(url, config).then(response => {
              this.available.years = response.data.years
            }).catch(err => {
              this.error = err
              this.error_data = err.response.data
              this.showError = true
            })
        },

        getMonths() {
            let url = process.env.BASE_URL + '/api/stats/' + this.user + '/' + this.year
            let config = {
              headers: {
                Token: sessionStorage.getItem('token')
              }
            }

            axios.get(url, config).then(response => {
              this.available.months = response.data.months
            }).catch(err => {
              this.error = err
              this.error_data = err.response.data
              this.showError = true
            })
        },

        getUsers() {
            let url = process.env.BASE_URL + '/api/stats'
            let config = {
              headers: {
                Token: sessionStorage.getItem('token')
              }
            }

            axios.get(url, config).then(response => {
              this.users = response.data.users
            }).catch(err => {
              this.error = err
              this.error_data = err.response.data
              this.showError = true
            })
        },

    },

    mounted () {
        this.getUsers()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Stats.vue